enum GovernPriority {
    Framework = 0,
    Notifications = 1,
    SuiteHeader = 2,
    Inbox = 3,
    Compose = 4,
    Analytics = 5,
    Messages = 6,
    Default = 10,
}

export { GovernPriority };
